export default __webpack_public_path__ + "ffef6eb38669edc1392122459cabfd48.jpg";